import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-contract-sign-success',
  templateUrl: './contract-sign-success.component.html',
  styleUrls: ['./contract-sign-success.component.css']
})
export class ContractSignSuccessComponent implements OnInit {

  registerId: any;
  personalData: any;
  companyData: any;

  constructor(
    private auth: AuthService,
    private activatedRouter: ActivatedRoute, 
    private route: ActivatedRoute, 
    private router: Router, 
    private registerService: RegisterService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();
    this.registerId = this.activatedRouter.snapshot.paramMap.get("registerId");
    
    this.registerService.getRegisteredUser().subscribe(data => {
      if(data){
        this.personalData = data.personalDetail;
        this.companyData = data.companyDetail;
      }
    });

    this.spinnerService.stop();
  }

  logOut(){
    this.spinnerService.start();
    /* this.router.navigate(['/home/']); */
    this.auth.logout();
    window.location.href = '/logout';
  }

}
